import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { UserProvider } from "./context/UserContext";
import { WalletProvider } from "./context/WalletContext";
import LandingPage from "./components/LandingPage";
import FeaturesSection from "./components/FeaturesSection";
import SampleQuizzesSection from "./components/SampleQuizzesSection";
import TrustSection from "./components/TrustSection";
import TestimonialsSection from "./components/TestimonialsSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import Dashboard from "./components/Dashboard";
import Profile from "./components/Profile";
import Wallet from "./components/Wallet";
import MyContests from "./components/MyContests";
import HelpSupport from "./components/HelpSupport";
import ContestDetail from "./components/ContestDetail";
import QuizInterface from "./components/QuizInterface";
import AuthModal from "./components/AuthModal";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoutes from "./routes/AdminRoutes";
import GlobalConfetti from "./components/animations/GlobalConfetti";
import NotificationPopup from "./components/NotificationPopup";
// import AnimationShowcase from "./components/AnimationShowcase";

const Home = () => {
  return (
    <div className="min-h-screen">
      <LandingPage />
      <FeaturesSection />
      <div id="sample-quizzes">
        <SampleQuizzesSection />
      </div>
      <TrustSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <UserProvider>
        <WalletProvider>
          <GlobalConfetti />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/profile" 
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/wallet" 
                element={
                  <ProtectedRoute>
                    <Wallet />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/my-contests" 
                element={
                  <ProtectedRoute>
                    <MyContests />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/help" 
                element={
                  <ProtectedRoute>
                    <HelpSupport />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/contest/:contestId" 
                element={
                  <ProtectedRoute>
                    <ContestDetail />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/quiz/:sessionId" 
                element={
                  <ProtectedRoute>
                    <QuizInterface />
                  </ProtectedRoute>
                } 
              />
              {/* Admin Routes */}
              <Route path="/admin/*" element={<AdminRoutes />} />
              {/* Redirect /home to /dashboard for logged in users */}
              <Route path="/home" element={<Navigate to="/dashboard" replace />} />
            </Routes>
            <AuthModal />
          </BrowserRouter>
        </WalletProvider>
      </UserProvider>
    </div>
  );
}

export default App;